module.exports = __webpack_public_path__ + "img/20220624140318.335ac69c.png";